
    import Vue from 'vue';
    import AsModal from '@/components/Ui/AsModal.vue';
    import AsHeadline from '@/components/Ui/AsHeadline.vue';
    import { settingsHelper } from '@/store/modules/settings';
    const settingsHelpers = settingsHelper.mapGetters(['providers']);

    export default Vue.extend({
	    name: 'WhatIsOpenBanking',
    	components: {
	    	AsModal,
		    AsHeadline,
	    },
    	computed: {
	    	...settingsHelpers,
		    yodlee(): boolean {
			    return this.providers.yodlee;
		    },
		    openBanking(): boolean {
			    return this.providers.openBanking;
		    },
	    },
    });
